import { useEffect } from "react";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@400;600;700;800;900&display=swap');

.del-overlay {
  position: fixed; inset: 0; z-index: 2000;
  background: rgba(3,7,15,0);
  display: flex; align-items: center; justify-content: center;
  padding: 20px; pointer-events: none;
  transition: background .3s ease;
  font-family: 'Heebo', sans-serif; direction: rtl;
}
.del-overlay.open {
  pointer-events: all;
  background: rgba(3,7,15,0.85);
  backdrop-filter: blur(6px);
}
.del-modal {
  background: #0b1622;
  border: 1px solid rgba(201,168,76,.2);
  border-radius: 20px;
  box-shadow: 0 32px 80px rgba(0,0,0,.7);
  padding: 32px 28px 28px;
  width: 100%; max-width: 400px;
  transform: scale(0.75) translateY(30px);
  opacity: 0;
  transition: transform .35s cubic-bezier(.22,1,.36,1), opacity .28s ease;
  text-align: center;
}
.del-overlay.open .del-modal { transform: scale(1) translateY(0); opacity: 1; }
.del-icon {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(224,82,82,.1); border: 2px solid rgba(224,82,82,.3);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 20px; font-size: 26px;
}
.del-title { font-size: 20px; font-weight: 900; color: #edf0f5; margin-bottom: 10px; }
.del-msg { font-size: 14px; color: #8da0b8; line-height: 1.6; margin-bottom: 28px; }
.del-msg strong { color: #edf0f5; font-weight: 700; }
.del-divider { height: 1px; background: rgba(255,255,255,.06); margin-bottom: 24px; }
.del-btns { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.del-btn {
  padding: 13px 0; border-radius: 10px;
  font-family: 'Heebo', sans-serif; font-size: 15px; font-weight: 800;
  cursor: pointer; transition: all .2s; border: none;
}
.del-btn--yes {
  background: linear-gradient(135deg, #e05252, #b83333);
  color: #fff; box-shadow: 0 4px 16px rgba(224,82,82,.3);
}
.del-btn--yes:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(224,82,82,.45); }
.del-btn--no {
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(255,255,255,.1) !important;
  color: #8da0b8;
}
.del-btn--no:hover { background: rgba(255,255,255,.09); color: #edf0f5; }
`;

export default function DeleteConfirmModal({ open, onClose, onConfirm, carName = "הרכב" }) {
  useEffect(() => {
    const fn = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [open, onClose]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <style>{css}</style>
      <div className={`del-overlay${open ? " open" : ""}`} onClick={onClose}>
        <div className="del-modal" onClick={(e) => e.stopPropagation()}>
          <div className="del-icon">🗑️</div>
          <div className="del-title">מחיקת רכב</div>
          <div className="del-msg">
            האם אתה בטוח שברצונך למחוק את<br />
            <strong>{carName}</strong>?<br />
            פעולה זו אינה ניתנת לביטול.
          </div>
          <div className="del-divider" />
          <div className="del-btns">
            <button className="del-btn del-btn--yes" onClick={() => { onConfirm(); onClose(); }}>
              כן, מחק
            </button>
            <button className="del-btn del-btn--no" onClick={onClose}>
              ביטול
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
